/** Canonical apex host for SEO (middleware 308s www → apex). */
export const SITE_HOST = "menuhunter.app";

export function getSiteUrl(): string {
  const raw =
    process.env.NEXT_PUBLIC_SITE_URL?.trim() ||
    process.env.NEXT_PUBLIC_WEB_BASE_URL?.trim() ||
    `https://${SITE_HOST}`;
  return raw.replace(/\/$/, "");
}

export const MARKETING_LOCALES = ["es", "en", "ca"] as const;
export type MarketingLocale = (typeof MARKETING_LOCALES)[number];

export function isMarketingLocale(value: string): value is MarketingLocale {
  return (MARKETING_LOCALES as readonly string[]).includes(value);
}

/** SEO landing path segments (no leading slash). */
export const SEO_TRILINGUAL_LANDING_SLUGS = [
  "menu-del-dia",
  "menu-del-dia-barcelona",
  "menu-del-dia-barcelona-gracia",
  "menu-del-dia-barcelona-eixample",
  "menu-del-dia-barcelona-sant-antoni",
  "menu-del-dia-barcelona-poblenou",
  "menu-del-dia-barcelona-el-raval",
  "menu-del-dia-barcelona-gotic",
  "menu-del-dia-barcelona-born",
] as const;
export type SeoTrilingualLandingSlug = (typeof SEO_TRILINGUAL_LANDING_SLUGS)[number];

export const SEO_LANDING_SLUGS = [
  ...SEO_TRILINGUAL_LANDING_SLUGS,
] as const;
export type SeoLandingSlug = (typeof SEO_LANDING_SLUGS)[number];

export function isSeoLandingSlug(value: string): value is SeoLandingSlug {
  return (SEO_LANDING_SLUGS as readonly string[]).includes(value);
}
